module.exports = __webpack_public_path__ + "img/1-2.cb07f5e6.jpg";